import { Component } from 'shimmer'

import { Letter } from '@/webGL/objects/Letter'

import dataLetter from '@/assets/data/letters'
import dataOrnements from '@/assets/data/ornements'

import Noise from 'simplex-noise'

import {
  MeshStandardMaterial,
  CubeTextureLoader,
  BoxGeometry,
  ConeGeometry,
  SphereGeometry,
  TorusGeometry,
  Box3,
  Vector3,
  TextureLoader,
  sRGBEncoding,
  Mesh
} from 'three'

const geometries = [
  {
    class: BoxGeometry,
    args: []

  },
  {
    class: ConeGeometry,
    args: [1, 1, 15, 1]
  },
  {
    class: SphereGeometry,
    args: [1, 15, 10]
  },
  {
    class: TorusGeometry,
    args: [1, .4, 15, 10]
  }
]
// cyan  red    grey    blue    yellow
const colors = [0x268424, 0xd42323, 0x111111, 0x161f8a, 0xccb12f]

const noiseAmp = .07
const noiseHalfAmp = noiseAmp * .5

export class Letters extends Component {
  constructor (getIntersectPosition) {
    super('Letters')

    this.onPointermove = this.onPointermove.bind(this)
    this.onUp = this.onUp.bind(this)
    this.onDestroy = this.onDestroy.bind(this)

    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })

    this.letters = []
    this.isUp = false

    dataLetter.forEach(data => {
      const letter = new Letter(null, data, getIntersectPosition)

      this.letters.push(letter)
      this.add(letter)
    })

    dataOrnements.forEach(data => {
      const index = Math.floor(Math.random() * geometries.length)
      const geometry = new geometries[index].class(...geometries[index].args)
      const material = new MeshStandardMaterial({
        color: colors[Math.floor(Math.random() * colors.length)],
        roughness: .6,
        metalness: .3
      })
      const letter = new Letter(new Mesh(geometry, material), data, getIntersectPosition)

      this.letters.push(letter)
      this.add(letter)
    })

    const envMapPromise = this.loadEnvMap()
    const mapPromise = this.loadMap()

    Promise.all(this.letters.map(letter => letter.promise)).then(() => {
      envMapPromise.then(texture => {
        this.letters.forEach(letter => {
          letter.setEnvMap(texture)
        })
      })
      mapPromise.then(texture => {
        this.letters.forEach(letter => {
          letter.setMap(texture)
        })
      })
      this.resolve()
    })

    this.noise = new Noise()
  }

  onPointermove (delta) {
    this.letters.forEach(letter => {
      letter.onPointermove(delta)
    })
  }

  onUp () {
    this.letters.forEach(letter => {
      letter.onUp()
    })
    this.isUp = true
  }

  onDown () {
    this.letters.forEach(letter => {
      letter.onDown()
    })
    this.isUp = false
  }

  get boxFull () {
    const box = new Box3().makeEmpty()
    dataLetter.forEach(data => {
      box.expandByPoint(new Vector3(data.position.x, data.position.y, data.position.z))
      box.expandByPoint(new Vector3(data.position.x, 0, data.position.z))
    })
    return box
  }

  onUpdate({elapsed}) {
    if (this.isUp) {
      this.letters.forEach((object, index) => {
        object.position.x = this.noise.noise2D(index, elapsed * .0001) * noiseAmp - noiseHalfAmp * object.progress
        object.position.y = this.noise.noise2D(index, elapsed * .0001) * noiseAmp - noiseHalfAmp * object.progress
        object.position.z = this.noise.noise2D(index, elapsed * .0001) * noiseAmp - noiseHalfAmp * object.progress
      })
    }
  }

  loadEnvMap () {
    return new Promise( (resolve, reject) => {
      const path = '/images/cubemap/'
      const format = '.png'
      const urls = [
        path + 'px' + format, path + 'nx' + format,
        path + 'py' + format, path + 'ny' + format,
        path + 'pz' + format, path + 'nz' + format
      ]

      const textureCube = new CubeTextureLoader().load( urls, resolve )
    })
  }

  loadMap () {
    return new Promise( (resolve, reject) => {
      new TextureLoader().load( '/images/textures/atlas--4.jpg', texture => {
        texture.encoding = sRGBEncoding
        texture.needsUpdate = true
        resolve(texture)
      })
    })
  }

  onDestroy () {
    this.letters.forEach(letter => {
      letter.onDestroy()
      this.remove(letter)
    })
    this.destroy()
  }
}